import { Button } from "@/components/ui/button";

/**
 * PrimaryButton — the standardized "main call-to-action" button.
 * Uses the brand accent (blue) — never black, never gray.
 *
 * Size tokens (matches page-level rhythm):
 *   sm  → h-8  text-[11px]   (compact toolbars, inline actions)
 *   md  → h-9  text-xs       (page-header actions, dialog footers)   ← default
 *   lg  → h-10 text-xs       (empty-state CTAs, prominent primaries)
 *
 * Contract mirrors shadcn Button (children, onClick, disabled, type, className, data-testid).
 */
const SIZE_CLS = {
    sm: "h-8 text-[11px]",
    md: "h-9 text-xs",
    lg: "h-10 text-xs",
};

export function PrimaryButton({ size = "md", className = "", children, ...rest }) {
    return (
        <Button
            className={`${SIZE_CLS[size]} bg-brand hover:bg-brand/90 text-brand-fg gap-1.5 ${className}`}
            {...rest}
        >
            {children}
        </Button>
    );
}

/**
 * SecondaryButton — outlined companion to PrimaryButton (cancels, secondary actions).
 * Kept here so both buttons share the exact same size tokens.
 */
export function SecondaryButton({ size = "md", className = "", children, ...rest }) {
    return (
        <Button
            variant="outline"
            className={`${SIZE_CLS[size]} gap-1.5 ${className}`}
            {...rest}
        >
            {children}
        </Button>
    );
}
